import React, { useState } from "react";
const estiloAgregados = require("./agregados.module.scss").default;
import * as R from "ramda";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons/faCheckSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalMU from "globalMU";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";

const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type EntitesProdutoAgregado = {
  Codigo: string;
  Descricao: string;
  Preco: number;
  Quantidade: number;
  Referencia: string;
  UnidadeAgregado: string;
  UserMessage: string;
  Transforming: boolean
};

export type AgregadosProps = {
  codigo: string;
  descricao: string;
  dadosAgregados: PagedMessageResponse<EntitesProdutoAgregado>;
  onOk: (agregadosSelecionados: EntitesProdutoAgregado[]) => void;
  corSelecionado: string;
  textoSelecionado: string;
  onPesquisarPaginado: (numeroPagina: number) => void
  foraOrcamento?: boolean
};

export const Agregados = (props: AgregadosProps) => {
  const [agregadosSelecionados, setAgregadosSelecionados] = useState<EntitesProdutoAgregado[]>([]);

  const toggleAgregadosSelecionado = (servicoAgregado: EntitesProdutoAgregado) => {
    if (agregadosSelecionados.includes(servicoAgregado)) {
      setAgregadosSelecionados(
        R.filter((e) => e != servicoAgregado, agregadosSelecionados)
      );
    } else {
      setAgregadosSelecionados(agregadosSelecionados.concat(servicoAgregado));
    }
  };

  const btnSelecionarTodos = <button
    className={`no-global-button ${estiloAgregados.button_check}`}
    id="Agregados_BtnSelecionarTodos"
    onClick={() => {
      // `?.` obrigatorio: um unico acesso desprotegido faz o React Compiler assumir que o
      // caminho nunca e nulo e propagar a premissa para as dependencias do memo cache, que
      // rodam no RENDER. Ver Aprendizado_React.md #React-341.
      const entidades = props.dadosAgregados?.Entities ?? []

      setAgregadosSelecionados(
        entidades.length != agregadosSelecionados.length ? entidades : []
      );
    }}
  >
    <FontAwesomeIcon
      color="#3c8ac9"
      className={estiloAgregados.icone_check}
      icon={faCheckSquare}
      fontSize={"23px"}
    />
    Selecionar todos
  </button>

  const detalheProdutoSelecionado = <div className={estiloAgregados.form}>
    <label>Produto</label>
    <div>{props.codigo}</div>
    <label>Descrição</label>
    <div>{props.descricao}</div>
  </div>

  const tableHead = <div className="_table-header-group"
    id="Agregados_TableHead"
  >
    <div className="_table-row">
      <div
        className={`_table-cell ${estiloAgregados.tableCellHeader}`}
      >
        Código
      </div>
      <div
        className={`_table-cell ${estiloAgregados.tableCellHeader}`}
      >
        Descrição
      </div>
      <div
        className={`_table-cell ${estiloAgregados.tableCellHeader}`}
      >
        Unidade
      </div>
      <div
        className={`_table-cell ${estiloAgregados.tableCellHeader}`}
        style={{ textAlign: "right" }}
      >
        Preço Unitário
      </div>
      <div
        className={`_table-cell ${estiloAgregados.tableCellHeader}`}
        style={{ textAlign: "right" }}
      >
        Quant.
      </div>
    </div>
  </div>

  const tableBody = <div className="_table-row-group"
    id="Agregados_TableBody"
  >
    {props.dadosAgregados?.Entities?.map((value) => (
      <div
        key={value.Codigo}
        className={`_table-row ${agregadosSelecionados.includes(value)
          ? estiloAgregados.linhaSelecionada
          : estiloAgregados.linha
          }`}
        style={
          agregadosSelecionados.includes(value)
            ? {
              backgroundColor: props.corSelecionado,
              color: props.textoSelecionado,
            }
            : {}
        }
        onClick={() => {
          toggleAgregadosSelecionado(value);
        }}
      >
        <div
          className={`_table-cell ${estiloAgregados.tableCellBody}`}
        >
          {value.Referencia}
        </div>
        <div
          className={`_table-cell ${estiloAgregados.tableCellBody}`}
        >
          {value.Descricao}
        </div>
        <div
          className={`_table-cell ${estiloAgregados.tableCellBody}`}
        >
          {value.UnidadeAgregado}
        </div>
        <div
          className={`_table-cell ${estiloAgregados.tableCellBody}`}
          style={{ textAlign: "right" }}
        >
          {globalMU.formatarValorNumerico(value.Preco, 2, true)}
        </div>
        <div
          className={`_table-cell ${estiloAgregados.tableCellBody}`}
          style={{ textAlign: "right" }}
        >
          {globalMU.formatarValorNumerico(value.Quantidade, 3)}
        </div>
      </div>
    ))}
  </div>

  const paginacao = props.dadosAgregados?.PageCount > 1 && (
    <Paginacao
      paginaAtual={props.dadosAgregados?.ActualPage}
      totalPaginas={props.dadosAgregados?.PageCount}
      id="Agregados_Paginacao"
      onAlterarListaSelecionada={props.onPesquisarPaginado}
    />
  )

  const btnOk = <button
    id ="Agregados_BtnOk"
    className={estiloAgregados.button}
    type="button"
    onClick={() => props.onOk(agregadosSelecionados)}
  >
    OK
  </button>

  return (
    <>
      <div
        id="agregados_container"
      >
        {detalheProdutoSelecionado}
        <br />
        {!props.foraOrcamento &&
        <div>
          {btnSelecionarTodos}
        </div>
        }
        <div className={estiloTabela.containerRolavel}
          id="agregados_container_tabela"
        >
          <div className={`_table _w-full _border-collapse ${estiloAgregados.tabelaAgregado}`}>
            {tableHead}
            {tableBody}

            {paginacao}
            {!props.foraOrcamento &&
            <div>
              {btnOk}
            </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};
